( function () {
    var sections = document.querySelectorAll( '.text-with-cards' );

    if ( ! sections.length || ! ( 'IntersectionObserver' in window ) ) {
        return;
    }

    if ( window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches ) {
        return;
    }

    sections.forEach( function ( section ) {
        var copy = section.querySelector( '.text-with-cards__copy' );
        var title = section.querySelector( '.text-with-cards__title' );
        var cards = Array.prototype.slice.call( section.querySelectorAll( '.text-with-cards__card' ) );
        var styles = window.getComputedStyle( section );
        var inset = styles.getPropertyValue( '--text-with-cards-reveal-inset' ).trim() || '12%';
        var cardsLead = durationMs( styles.getPropertyValue( '--text-with-cards-reveal-cards-lead' ), 550 );
        var copyRevealedAt = null;
        var observer;
        var resizeTimer;

        if ( ! copy && ! cards.length ) {
            section.setAttribute( 'data-reveal-skip', '' );
            return;
        }

        if ( title ) {
            splitTitle( title );
        }

        section.classList.add( 'is-reveal' );
        assignLines( title );
        assignIndexes( cards );

        observer = new IntersectionObserver( function ( entries ) {
            entries.forEach( function ( entry ) {
                if ( ! entry.isIntersecting ) {
                    return;
                }

                if ( entry.target === copy ) {
                    revealCopy();
                } else {
                    revealCard( entry.target );
                }
            } );
        }, {
            rootMargin: '0px 0px -' + inset + ' 0px',
            threshold: 0
        } );

        // Let the hidden state paint before observing, so content already on screen still animates in.
        window.requestAnimationFrame( function () {
            window.requestAnimationFrame( function () {
                if ( copy ) {
                    observer.observe( copy );
                }

                cards.forEach( function ( card ) {
                    observer.observe( card );
                } );
                revealIfPageEnds();
            } );
        } );

        onRevealPageEnd( revealIfPageEnds );
        window.addEventListener( 'resize', onResize );

        function onResize() {
            window.clearTimeout( resizeTimer );
            resizeTimer = window.setTimeout( function () {
                if ( copyRevealedAt === null ) {
                    assignLines( title );
                }

                assignIndexes( cards.filter( function ( card ) {
                    return ! card.classList.contains( 'is-inview' );
                } ) );
                revealIfPageEnds();
            }, 150 );
        }

        function revealIfPageEnds() {
            var atEnd = window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 4;

            if ( ! atEnd ) {
                return;
            }

            revealCopy();
            cards.forEach( function ( card ) {
                revealCard( card );
            } );
        }

        function revealCopy() {
            if ( ! copy || copyRevealedAt !== null ) {
                return;
            }

            copyRevealedAt = Date.now();
            section.classList.add( 'is-copy-inview' );
            observer.unobserve( copy );
        }

        function revealCard( card ) {
            var lead = 0;

            if ( card.classList.contains( 'is-inview' ) ) {
                return;
            }

            if ( copy && copyRevealedAt === null && isOnScreen( copy ) ) {
                revealCopy();
            }

            if ( copyRevealedAt !== null ) {
                lead = Math.max( 0, cardsLead - ( Date.now() - copyRevealedAt ) );
            }

            card.style.setProperty( '--text-with-cards-reveal-lead', lead + 'ms' );
            card.classList.add( 'is-inview' );
            observer.unobserve( card );
        }
    } );

    function onRevealPageEnd( callback ) {
        if ( window.JPSReveal ) {
            window.JPSReveal.onEnd( callback );
            return;
        }

        window.addEventListener( 'scroll', callback, { passive: true } );
    }

    function splitTitle( title ) {
        var text = title.textContent;
        var fragment = document.createDocumentFragment();

        title.setAttribute( 'aria-label', text.trim() );

        text.split( /(\s+)/ ).forEach( function ( part ) {
            var mask;
            var word;

            if ( ! part ) {
                return;
            }

            if ( /^\s+$/.test( part ) ) {
                fragment.appendChild( document.createTextNode( ' ' ) );
                return;
            }

            mask = document.createElement( 'span' );
            mask.className = 'text-with-cards__title-mask';
            mask.setAttribute( 'aria-hidden', 'true' );

            word = document.createElement( 'span' );
            word.className = 'text-with-cards__title-word';
            word.textContent = part;

            mask.appendChild( word );
            fragment.appendChild( mask );
        } );

        title.textContent = '';
        title.appendChild( fragment );
    }

    function assignLines( title ) {
        var line = -1;
        var lastTop = null;

        if ( ! title ) {
            return;
        }

        title.querySelectorAll( '.text-with-cards__title-mask' ).forEach( function ( mask ) {
            var top = mask.offsetTop;

            if ( lastTop === null || Math.abs( top - lastTop ) > 4 ) {
                line++;
                lastTop = top;
            }

            mask.firstChild.style.setProperty( '--text-with-cards-reveal-line', String( line ) );
        } );
    }

    function assignIndexes( cards ) {
        var rows = [];

        cards.forEach( function ( card ) {
            var top = card.getBoundingClientRect().top;
            var row = null;
            var i;

            for ( i = 0; i < rows.length; i++ ) {
                if ( Math.abs( rows[ i ].top - top ) < 8 ) {
                    row = rows[ i ];
                    break;
                }
            }

            if ( ! row ) {
                row = { top: top, cards: [] };
                rows.push( row );
            }

            row.cards.push( card );
        } );

        rows.forEach( function ( row ) {
            row.cards.sort( function ( a, b ) {
                return a.getBoundingClientRect().left - b.getBoundingClientRect().left;
            } );

            row.cards.forEach( function ( card, index ) {
                card.style.setProperty( '--text-with-cards-reveal-index', String( index ) );
            } );
        } );
    }

    function isOnScreen( element ) {
        var rect = element.getBoundingClientRect();

        return rect.top < window.innerHeight && rect.bottom > 0;
    }

    function durationMs( raw, fallback ) {
        raw = ( raw || '' ).trim();

        if ( raw.slice( -2 ) === 'ms' ) {
            return parseFloat( raw ) || fallback;
        }

        return ( parseFloat( raw ) * 1000 ) || fallback;
    }
} )();
